import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    areaList: (localStorage.getItem('areaList') !== 'undefined' && localStorage.getItem('areaList') != null) ? JSON.parse(localStorage.getItem('areaList')) : [],
    userInfo: (localStorage.getItem('userInfoNew') !== 'undefined' && localStorage.getItem('userInfoNew') != null) ? JSON.parse(localStorage.getItem('userInfoNew')) : {},
    cartNum: 0
  },
  mutations: {
    SET_AREALIST: (state, areaList) => {
      state.areaList = areaList
      localStorage.setItem('areaList', JSON.stringify(areaList))
    },
    SET_USER_INFO: (state, userInfo) => {
      state.userInfo = userInfo
      localStorage.setItem('userInfoNew', JSON.stringify(userInfo))
    },
    SET_CART_NUM: (state, cartNum) => {
      state.cartNum = cartNum
      localStorage.setItem('cartNum', cartNum)
    }
  },
  actions: {
    setAreaList ({ commit }, data) {
      commit('SET_AREALIST', data)
    },
    // get user info
    setUserInfo ({ commit }, data) {
      commit('SET_USER_INFO', data)
    },
    setcartNum ({ commit }, data) {
      commit('SET_CART_NUM', data)
    }
  }
})
